import { render, staticRenderFns } from "./EvaluationsSelectbox.vue?vue&type=template&id=55a61172"
import script from "./EvaluationsSelectbox.vue?vue&type=script&lang=js"
export * from "./EvaluationsSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports